import { createAction } from 'redux-actions';

export const setEmailAccount = createAction('SET_EMAIL_ACCOUNT');
